import React, { useContext, useEffect, useState } from 'react'
import { WrapDataGrid } from 'components/DataGrid/Style'
import { useTheme } from 'styles'
import { EmptyScreen, labHooks, WordDefsWithFrequency, WordFrequency } from '.'
import { Tabs } from 'components'
import { isEmpty } from 'lodash'
import { IconButton } from '@mui/material'
import { actions } from 'store'
import { useDispatch } from 'react-redux'
import { CustomSection } from 'styles/GlobalStyle'
import { LinguisticLabContext } from './LinguisticLabContext'
import { GraphicEq } from '@mui/icons-material'
import { thirdly2 } from 'styles/theme'
import { RatingDials } from 'components/Rating'
import { LabStyles } from './Style'
import { Button } from 'components/Form'
import Graphs from './Graphs'
import FilterManager from 'components/FilterManager'

const LinguisticLab = () => {
    const dispatch = useDispatch()

    const [openGraphs, setOpenGraphs] = useState(false)

    const { selectedTab, setSelectedTab, assessmentFilters, setAssessmentFilters } = useContext(LinguisticLabContext)

    const { Layout } = useTheme()

    const { frequencyItems } = labHooks.constants
    const { data: frequency, refetch: refetchFrequency, isFetching: getFrequencyLoading } = labHooks.useFrequency()

    const tabs = labHooks.useTabs()

    const filterSchema = {
        primary: [
            { key: "grade_of_execution" },
            { key: "semester" },
            { key: "categories" },
            { key: "assessment_defs" }
        ]
    }

    const cleanData = () => {
        dispatch(actions.cleanAssessmentFilters({}))
    }

    const handleTab = (index) => {
        setSelectedTab(index)
    }

    useEffect(() => {
        return () => {
            cleanData()
        }
    }, [])

    useEffect(() => {
        if (frequency)
            refetchFrequency()
    }, [selectedTab])

    return (
        <LabStyles>
            <WrapDataGrid>
                <div className='lab-filters'>
                    <div className='fx'>
                        <FilterManager
                            schema={filterSchema}
                            values={assessmentFilters}
                            onChange={setAssessmentFilters}
                        />
                    </div>
                    <Button
                        variant="regular"
                        disabled={!assessmentFilters.assessment_defs}
                        label={"סנן מבדקים"}
                        action={refetchFrequency}
                        height={'40px'}
                        width={'108px'}
                        color={"thirdly1"}
                        loading={getFrequencyLoading}
                    />
                </div>
                <div className='wrap-accuracy-tabs'>

                    {isEmpty(frequency) ||
                        <div className='accuracy-tabs'>
                            <Tabs tabs={tabs} handleTab={handleTab} />
                        </div>}

                    <div className='open-graph-icon'>
                        <IconButton onClick={() => setOpenGraphs(true)}>
                            <GraphicEq />
                        </IconButton>
                    </div>
                </div>
                {isEmpty(frequency) ||
                    <React.Fragment>
                        <RatingDials
                            buttonSize={{ width: 210 }}
                            levels={frequencyItems} label="דירוג קריאוּת (readability):" />


                        <div style={{ ...Layout.col, ...Layout.lrGap, ...Layout.grow, ...Layout.overflow }}>
                            <CustomSection $border={thirdly2} $shrink height={50} $flex align="center">
                                {`תוצאות מבוססות  על ${frequency?.assessment_count} מבדקים על פי הסינון`}
                            </CustomSection>

                            <div style={{ ...Layout.grow, ...Layout.flex, ...Layout.fullHeight, ...Layout.lcGap, ...Layout.overflow }}>

                                <WordDefsWithFrequency
                                    {...frequency}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                }

                {!isEmpty(frequency) || <EmptyScreen />}

                {/* Left Drawer Graph*/}
                <Graphs
                    open={openGraphs}
                    setOpen={setOpenGraphs}
                    assessmentFilters={assessmentFilters}
                    wordDefCount={frequency?.word_defs.length} />

                {/* Bottom Drawer Stats */}
                <WordFrequency />
            </WrapDataGrid>
        </LabStyles>
    )
}

export default LinguisticLab
